import React from 'react'
import { BCol, BRow, BText, BTitle } from '@prague-digi/ui-components'

import { intl, IntlInterface } from '../../hoc'
import messages from '../../i18n'
import styles from './styles.scss'

type Props = IntlInterface & {
  center?: boolean
  img?: any
  message: any
  subTitle: boolean
  subtitleJsx: React.ElementType
  subTitleMessage: any
}

export const Title = ({
  center,
  img,
  message,
  subTitle,
  subtitleJsx,
  subTitleMessage,
  translate,
}: Props) => (
  <>
    {!!img && (
      <BRow>
        <BCol theme="text-center">
          <img src={img} alt="icon" className={styles.icon} />
        </BCol>
      </BRow>
    )}
    <BTitle type="h3" center={center}>
      {translate(message)}
    </BTitle>

    {subTitle && (
      <BText data-test-id="subTitle" type="secondary">
        {subtitleJsx || translate(subTitleMessage || messages.common.subTitle)}
      </BText>
    )}
  </>
)

export default React.memo(intl(Title))
